// tslint:disable max-line-length

import * as Constants from "Data/Constants";
import {LONDON as VO} from "Data/VO";
import type { ILocationConfig } from "Interfaces/ILocationConfig";

const offset = -35;

export const LondonConfig: ILocationConfig = {
  city: "London",
  country: "UK",
  interior: {
    width: 1664,
    itemslist: {
       give: {
          bg: [
            { filename: "bottomjuggler", x: 7, y: 555.25 - 384 + offset},
            { filename: "circoticket", x: 0, y: 305 - 384 + offset}, // eyeballed
          ],
          ICON_SIZE: 110,
          ICON_SPACING: 13.5,
          columns: 4,
          floatingItemsY: -140 + offset, // eyeballed
          width: 505,
          highlightFloatingItems: false,
          animateIn: "slideInFromRight",
      },
      return: {
        width: 1664,
        height: 768,
        highlightFloatingItems: false,
        floatingItemsY: -300,
        ICON_SIZE: 80,
        ICON_SPACING: 20,
        bg: [
          { filename: "topjuggler", x: 817 - 832, y: (364 - 172.5) / 2 },
        ],
        animateOut: "juggle",
        itemslots: {
          width: 80,
          height: 78.5,
          bg: [{filename: "itemring", x: 40, y: 39.25}],
          radius: 190,
          length: 4,
          rotationoffset: 20,
          y: offset,
          dropSFX: "boomarang-loop",
        },
        doCheerSound: true,
      },
    },
    bg: { filename: "london-int-bg" },
  },
  exterior: {
    bg: [
      { filename: "london-ext-bg1", x: 0, y: 0 },
      { filename: "london-ext-bg2", x: 2048, y: 0 },
    ],
    margin: {
      left: 20,
      right: 20,
    },
    width: 3072,
  },
  items: {
    crisps: {
        name: "Crisps",
        sprite: "crisps-full",
        sprite_hat: "crisps-full",
        icon_ext: "crisps-on",
        icon_int_give: "crisps-full",
        icon_int_return: "crisps-full",
        vo: {
          found: VO.ITEMS.IL5B,
          returned: VO.ITEMS.IL5A,
          fact: VO.FACTS.FL8,
        },
    },
    teapot: {
        name: "Teapot",
        sprite: "teapot-full",
        sprite_hat: "teapot-full",
        icon_ext: "teapot-on",
        icon_int_give: "teapot-full",
        icon_int_return: "teapot-full",
        vo: {
          found: VO.ITEMS.IL3B,
          returned: VO.ITEMS.IL3A,
          fact: VO.FACTS.FL3,
        },
    },
    doubledecker: {
        name: "Double-Decker Bus",
        sprite: "doubledecker-full",
        sprite_hat: "doubledecker-full",
        icon_ext: "doubledecker-on",
        icon_int_give: "doubledecker-full",
        icon_int_return: "doubledecker-full",
        vo: {
          found: VO.ITEMS.IL6B,
          returned: VO.ITEMS.IL6A,
        },
    },
    shepherdspie: {
        name: "Shepherd's Pie",
        sprite: "shephardspie-full",
        sprite_hat: "shephardspie-full",
        icon_ext: "shephardspie-on",
        icon_int_give: "shephardspie-full",
        icon_int_return: "shephardspie-full",
        vo: {
          found: VO.ITEMS.IL1B,
          returned: VO.ITEMS.IL1A,
          fact: VO.FACTS.FL5,
        },
    },
    football: {
        name: "Football",
        sprite: "football-full",
        sprite_hat: "football-full",
        icon_ext: "football-on",
        icon_int_give: "football-full",
        icon_int_return: "football-full",
        vo: {
          found: VO.ITEMS.IL2B,
          returned: VO.ITEMS.IL2A,
          fact: VO.FACTS.FL7,
        },
    },
    biscuits: {
        name: "Biscuits",
        sprite: "buiscuits-full",
        sprite_hat: "buiscuits-full",
        icon_ext: "buiscuits-on",
        icon_int_give: "buiscuits-full",
        icon_int_return: "buiscuits-full",
        vo: {
          found: VO.ITEMS.IL8B,
          returned: VO.ITEMS.IL8A,
          fact: VO.FACTS.FL10,
        },
    },
    candyfloss: {
        name: "Candy Floss",
        sprite: "candyfloss-full",
        sprite_hat: "candyfloss-full",
        icon_ext: "candyfloss-on",
        icon_int_give: "candyfloss-full",
        icon_int_return: "candyfloss-full",
        vo: {
          found: VO.ITEMS.IL4B,
          returned: VO.ITEMS.IL4A,
          fact: VO.FACTS.FL9,
        },
    },
    bangersmash: {
        name: "Bangers and Mash",
        sprite: "bangersmash-full",
        sprite_hat: "bangersmash-full",
        icon_ext: "bangersmash-on",
        icon_int_give: "bangersmash-full",
        icon_int_return: "bangersmash-full",
        vo: {
          found: VO.ITEMS.IL10B,
          returned: VO.ITEMS.IL10A,
          fact: VO.FACTS.FL6,
        },
    },
    umbrella: {
        name: "Umbrella",
        sprite: "umbrella-full",
        sprite_hat: "umbrella-full",
        icon_ext: "umbrella-on",
        icon_int_give: "umbrella-full",
        icon_int_return: "umbrella-full",
        vo: {
          found: VO.ITEMS.IL9B,
          returned: VO.ITEMS.IL9A,
        },
    },
    fishchips: {
        name: "Fish and Chips",
        sprite: "fishchips-full",
        sprite_hat: "fishchips-full",
        icon_ext: "fishchips-on",
        icon_int_give: "fishchips-full",
        icon_int_return: "fishchips-full",
        vo: {
          found: VO.ITEMS.IL7B,
          returned: VO.ITEMS.IL7A,
          fact: VO.FACTS.FL4,
        },
    },
  },
  payoffs: {
    payoff1: {name: "Payoff 1"},
  },
  hidingspots: {
    "openwindow": {
      foreground: { sprite: "openwindow-front", x: 221.5, y: 22},
      background: { sprite: "openwindow-back", x: 259.5, y: 79.5 },
      hitarea: {x: 308, y: 186.5},
    },
    "chiptruck": {foreground: {sprite: "chiptruck", x: 105, y: 414.5}, hitarea: {x: 325, y: 493}},
    "underground": {
      foreground: { sprite: "underground-front", x: 0, y: 96 },
      background: { sprite: "underground-back", x: 749 - 752.7, y: 119 },
      hitarea: { x: 458.5, y: 741}, // x: 563.5, y: 240
    },
    "lamppost": {foreground: {sprite: "lamppost", x: 232 - 321.7, y: 18}, hitarea: {x: 116, y: 393}},
    "phoneboothnews": {foreground: {sprite: "phoneboothnews", x: 727, y: 351}, hitarea: {x: 798, y: 572.5}},
    "flagleft": {foreground: {sprite: "flagleft", x: 914, y: 169.5 - 200.7}, hitarea: {x: 975, y: 83.5}},
    "flagright": {background: {sprite: "flagright", x: 1539, y: 180 - 203.7}, hitarea: {x: 1598.5, y: 90}},
    "fruitstandleft": {background: {sprite: "fruitstandleft", x: 872.5, y: 366}, hitarea: {x: 957.5, y: 432}},
    "fruitstandright": {foreground: {sprite: "fruitstandright", x: 1362.5, y: 378}, hitarea: {x: 1617.5, y: 443}},
    "car-black": {foreground: {sprite: "car-black", x: 1046.5, y: 483.5}, hitarea: {x: 1289, y: 556.5}},
    "uksign": {foreground: {sprite: "uksign", x: 1839, y: 74}, hitarea: {x: 2096, y: 137}},
    "ukbuildingface1": {foreground: {sprite: "ukbuildingface1", x: 1837, y: 196.5}, hitarea: {x: 2098, y: 327.5}},
    "billboard": {foreground: {sprite: "billboard", x: 2486, y: 31.5}, hitarea: {  x: 2580, y: 149.5}},
    "feelsrightbuilding": {foreground: {sprite: "feelsrightbuilding", x: 2278, y: 166}, hitarea: {x: 2466.25, y: 306.5}},
    "clothierawning": {foreground: {sprite: "clothierawning", x: 2889, y: 190.5}, hitarea: {x: 2984, y: 248}},
    "trashcan": {foreground: {sprite: "trashcan", x: 1753.5, y: 392}, hitarea: {x: 1801.5, y: 444}},
    "car-red": {foreground: {sprite: "car-red", x: 2235, y: 409}, hitarea: {x: 2350, y: 467.5}},
    "car-green": {foreground: {sprite: "car-green", x: 1793, y: 493}, hitarea: {x: 1966.5, y: 573}},
    "lamppost2": {foreground: {sprite: "lamppost", x: 1548.5, y: 18}, hitarea: {x: 1708.5, y: 239.5}},
    "flowerbush1": {foreground: {sprite: "flowerbush1", x: 1284, y: 657}, hitarea: {x: 1524, y: 733}},
    "flowerbush2": {foreground: {sprite: "flowerbush2", x: 2323.5, y: 638.5}, hitarea: {x: 2517.5, y: 731}},
    "busstand": {
      background: {sprite: "busstand-back", x: 2695.5, y: 582},
      foreground: {sprite: "busstand-front", x: 2677.5, y: 447},
      hitarea: {x: 2884.5, y: 750.5}, // x: 2878, y: 474.5}
    },
  },
  npc: {
    name: "Wigglewalker",
    poses: {
      neutral: {sprite: "npc-wigglewalker-neutral", position: {x: -2, y: 0}},
      excited: {sprite: "npc-wigglewalker-excited", position: {x: -12, y: 0}},
    },
  },
  vo: {
    give_quest: [VO.GIVE.L1],
    show_items: [VO.GIVE.L2, Constants.VO_SPACING, VO.GIVE.L3],
    give_quest_idle: [VO.GIVE.L4, VO.GIVE.L5],
    return_items: [VO.RETURN.L8, Constants.VO_SPACING, VO.RETURN.L9],
    return_items_idle: [VO.RETURN.L9],
    exterior: [VO.EXTERIOR.L6, Constants.VO_SPACING, VO.EXTERIOR.L7],
    exterior_idle: [VO.FACTS.FL1, VO.FACTS.FL2],
    all_items_returned_idle: [VO.RETURN.L13],
  },
  narratives: [
    {
      variations: [
// Level 1
        {
          hiddenitems: [
            {hidingspot: "chiptruck", item: { id: "shepherdspie", rotation: -13.49, scale: 0.4174, position: {x: -136.25, y: -65.5}}},
            {hidingspot: "phoneboothnews", item: { id: "football", rotation: 0, scale: 0.4395, position: {x: 66.5, y: -29.43}}},
            {hidingspot: "uksign", item: { id: "teapot", rotation: -11.85, scale: 0.3526, position: {x: -175.5, y: -41.5}}},
            {hidingspot: "busstand", item: { id: "candyfloss", rotation: -12.59, scale: 0.4556, position: {x: 96.25, y: -59.25}}},
          ],
          itemslist: {
            give: {
              columns: 2,
            },
          },
          vo: {
            all_items_returned: [VO.RETURN.L10, Constants.VO_SPACING, VO.RETURN.L13],
          },
        },
// Level 2
        {
            hiddenitems: [
              {hidingspot: "flagleft", item: { id: "crisps", rotation: -37.87, scale: 0.3560, position: {x: -47.75, y: -7.75}}},
              {hidingspot: "flowerbush1", item: { id: "doubledecker", rotation: 12.97, scale: 0.5574, position: {x: -200.5, y: 14.25}}},
              {hidingspot: "fruitstandright", item: { id: "fishchips", rotation: 0, scale: 0.5169, position: {x: -4.99, y: -47.88}}},
              {hidingspot: "lamppost2", item: { id: "biscuits", rotation: 0, scale: 0.4588, position: {x: 42.48, y: -20.67}}},
              {hidingspot: "car-red", item: { id: "umbrella", rotation: -32.60, scale: 0.5873, position: {x: -46.5, y: -31.75}}},
            ],
            itemslist: {
              give: {
                columns: 3,
              },
              return: {
                itemslots: {
                  width: 80,
                  height: 78.5,
                  bg: [{filename: "itemring", x: 40, y: 39.25}],
                  radius: 190,
                  length: 5,
                  rotationoffset: 40,
                  y: offset,
                  dropSFX: "boomarang-loop",
                },
              },
            },
            vo: {
              all_items_returned: [VO.RETURN.L11, Constants.VO_SPACING, VO.RETURN.L13],
            },
        },
// Level 3
        {
          hiddenitems: [
            {hidingspot: "chiptruck", item: { id: "teapot", rotation: 0, scale: 0.4227, flipX: true, position: {x: 123.65 + 15, y: 86.03 - 15}}},
            {hidingspot: "openwindow", item: { id: "football", rotation: 0, scale: 0.3311, position: {x: 10.58, y: -36.18}}},
            {hidingspot: "car-black", item: { id: "bangersmash", rotation: 0, scale: 0.4334, position: {x: 136.94, y: 20.38}}},
            {hidingspot: "flowerbush2", item: { id: "fishchips", rotation: 0, scale: 0.49, position: {x: -36.5, y: -59}}},
            {hidingspot: "billboard", item: { id: "candyfloss", rotation: 132.41, scale: 0.4142, position: {x: 48.95, y: 45}}},
          ],
          itemslist: {
            give: {
              columns: 3,
            },
            return: {
              itemslots: {
                width: 80,
                height: 78.5,
                bg: [{filename: "itemring", x: 40, y: 39.25}],
                radius: 190,
                length: 5,
                rotationoffset: 40,
                y: offset,
                dropSFX: "boomarang-loop",
              },
            },
          },
          vo: {
            all_items_returned: [VO.RETURN.L12, Constants.VO_SPACING, VO.RETURN.L13],
          },
        },
// Level 4
        {
          hiddenitems: [
            {hidingspot: "underground", item: { id: "biscuits", rotation: 0, scale: 0.4361, position: {x: -35, y: -596.75}}},
            {hidingspot: "phoneboothnews", item: { id: "doubledecker", rotation: 160.64 - 180, scale: 0.5889, flipX: true, position: {x: -32.5, y: 21}}},
            {hidingspot: "trashcan", item: { id: "teapot", rotation: 0, scale: 0.4409, position: {x: 27 + 15, y: -3}}},
            {hidingspot: "uksign", item: { id: "umbrella", rotation: -12.74, scale: 0.5913, position: {x: 34.25, y: -45}}},
            {hidingspot: "clothierawning", item: { id: "crisps", rotation: 38.02, scale: 0.3657, position: {x: 45.5 - 100, y: 27.25 + 10}}},
            {hidingspot: "flowerbush1", item: { id: "shepherdspie", rotation: -12.20, scale: 0.4099, position: {x: 93.25, y: -44}}},
          ],
          itemslist: {
            give: {
              columns: 3,
            },
            return: {
              itemslots: {
                width: 80,
                height: 78.5,
                bg: [{filename: "itemring", x: 40, y: 39.25}],
                radius: 190,
                length: 6,
                rotationoffset: 50,
                y: offset,
                dropSFX: "boomarang-loop",
              },
            },
          },
          vo: {
            all_items_returned: [VO.RETURN.L10, Constants.VO_SPACING, VO.RETURN.L13],
          },
        },
// Level 5
        {
          hiddenitems: [
            {hidingspot: "openwindow", item: { id: "candyfloss", rotation: 25.70, scale: 0.2756, position: {x: -10, y: -33.25}}},
            {hidingspot: "flagleft", item: { id: "umbrella", rotation: -72.22, scale: 0.6237, position: {x: -17, y: -18.25}}},
            {hidingspot: "phoneboothnews", item: { id: "fishchips", rotation: 0, scale: 0.4902, position: {x: -6.5, y: -212.5}}},
            {hidingspot: "car-black", item: { id: "teapot", rotation: 0, scale: 0.4924, position: {x: 54.5, y: -16.5}}},
            {hidingspot: "lamppost2", item: { id: "crisps", rotation: -15.42, scale: 0.4545, position: {x: 16.5, y: 25.25}}},
            {hidingspot: "car-red", item: { id: "football", rotation: 0, scale: 0.4145, position: {x: 70.5, y: -15.25}}},
            {hidingspot: "clothierawning", item: { id: "biscuits", rotation: 0, scale: 0.2878, position: {x: -61.37, y: 5.2}}},
            {hidingspot: "busstand", item: { id: "doubledecker", rotation: 18.00, scale: 0.5412, position: {x: 98, y: -149}}},
          ],
          itemslist: {
            return: {
              itemslots: {
                width: 80,
                height: 78.5,
                bg: [{filename: "itemring", x: 40, y: 39.25}],
                radius: 190,
                length: 8,
                rotationoffset: 20,
                y: offset,
                dropSFX: "boomarang-loop",
              },
            },
          },
          vo: {
            all_items_returned: [VO.RETURN.L11, Constants.VO_SPACING, VO.RETURN.L13],
          },
        },
      ],
      payoff: "payoff1",
    },
  ],
  bgm: "LATW_353_grand_regal_majestic_pacer_london_AB_extended",
};
